
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `더 많은 기능과 쉬운 접근을 위해 홈 화면에 추가해주세요.`,
's224cbcec014ef6b5': `내비게이션 바에서 공유 버튼 누르기`,
's37a9e8aec5713460': `더보기`,
's386eca8362ff6155': `공유 아이콘이 없으면 더보기 누르기`,
's4e1e10a6ca408245': `"홈 화면에 추가" 탭하기`,
's6196153c4b0c1ea0': `설치`,
's633502f7cff4f847': `브라우저 메뉴 열기`,
's681e399d63311fba': `갤러리 표시`,
's7f0591f08e318eda': `공유 메뉴에서 더보기 누르기`,
's8114bd55cae5a22b': `Dock에 추가 버튼 누르기`,
's922329d6f6213590': `Dock에 추가`,
's9af56bf005b49c74': `"홈 화면에 추가"로 스크롤하기`,
'sa5ef80b4bb9b39f8': `닫기`,
'sba52286c21552a4e': `더 많은 기능과 쉬운 접근을 위해 기기에 설치해주세요.`,
'sc16e00a7a8b2fde2': `뒤로`,
'scdaf4bbff76674c8': `홈 화면에 추가`,
'se0e473adfda8066c': `주 브라우저에서 열기`,
'se740f75b95a51807': `더 많은 기능과 쉬운 접근을 위해 Dock에 추가해주세요.`,
'sfea652f6580ff086': `이 사이트는 앱 기능을 가지고 있습니다.`,
    };
  